"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _timer = require("@package/timer");

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultsModule = _interopRequireDefault(require("./defaults.module.scss"));

function useTimeout(isUse) {
  var timer = (0, _react.useRef)(null);

  if (!isUse) {
    return null;
  }

  if (!timer['current']) {
    timer['current'] = new _timer.Timeout();
  }

  return timer['current'];
}

function Notification(_ref) {
  var uuid = _ref.uuid,
      title = _ref.title,
      content = _ref.content,
      mode = _ref.mode,
      autoClose = _ref.autoClose,
      timeout = _ref.timeout,
      allowHTML = _ref.allowHTML,
      onClose = _ref.onClose;
  var classNameClose = (0, _react.useMemo)(function () {
    return (0, _classnames["default"])('fas fa-times', _defaultsModule["default"]['close']);
  }, []);
  var classNameNotification = (0, _react.useMemo)(function () {
    var _cn;

    return (0, _classnames["default"])(_defaultsModule["default"]['wrapper'], (_cn = {}, (0, _defineProperty2["default"])(_cn, _defaultsModule["default"]['mode--success'], mode === 'success'), (0, _defineProperty2["default"])(_cn, _defaultsModule["default"]['mode--danger'], mode === 'danger'), (0, _defineProperty2["default"])(_cn, _defaultsModule["default"]['mode--primary'], mode === 'primary'), (0, _defineProperty2["default"])(_cn, _defaultsModule["default"]['mode--warning'], mode === 'warning'), _cn));
  }, []);
  var timer = useTimeout(autoClose);

  function handleClose() {
    onClose(uuid);
  }

  (0, _react.useEffect)(function () {
    if (timer) {
      timer.start(function () {
        return handleClose();
      }, timeout);
    }

    return function () {
      if (timer) {
        timer.reset();
      }
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classNameNotification,
    "data-locator": "notification"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classNameClose,
    onClick: handleClose
  }), mode && /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultsModule["default"]['image']
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultsModule["default"]['icon']
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultsModule["default"]['content']
  }, title && /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultsModule["default"]['title'],
    role: "header",
    title: title,
    "data-locator": "notification.header"
  }, title), content && (allowHTML ? /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultsModule["default"]['text'],
    "data-locator": "notification.content",
    dangerouslySetInnerHTML: {
      __html: content
    }
  }) : /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultsModule["default"]['text'],
    "data-locator": "notification.content"
  }, content))));
}

Notification.defaultProps = {
  uuid: null,
  autoClose: true,
  timeout: 4,
  title: '',
  content: '',
  mode: 'default',
  allowHTML: false
};
var _default = Notification;
exports["default"] = _default;